/**
 * @name: emailRoutes
 * @author: weiyong
 * @date: 2026-01-22 17:22
 * @description：邮件管理子路由配置
 * @update: 2026-01-22 17:22
 *
 */

// 写信页面
const proPlanMain = () => import('../../../views/proPlanMain/mainPage.vue');

export default [
  {
    path: '/proPlanMain',
    name: 'proPlanMain',
    component: proPlanMain,
    meta: {
      title: '主计划排产',
      rightPanel: 'proPlanMain',
    },
  },
  {
    path: '/proPlanMainQuery',
    name: 'proPlanMainQuery',
    component: proPlanMain,
    meta: {
      title: '主计划查询',
      rightPanel: 'proPlanMain',
      hideScheduleButtons: true, // 隐藏计划排产、滚动排产、插单排产按鈕
    },
  },
];
